const React = require('react');
const { includes } = require('lodash');
const classNames = require('classnames');
const NumericInput = require('./numeric_input.jsx');
const Currency = require('components/shared/currency');

const UNSUPPORTED_FA_ICONS = ['AUD', 'CAD'];

class PriceFieldWithCurrency extends React.Component {
  input = () => {
    return this.refs.input.refs.input;
  };

  renderSymbol = () => {
    const currencyForIcon = includes(UNSUPPORTED_FA_ICONS, this.props.currency) ? 'usd' : this.props.currency;
    if (!currencyForIcon) { return null; }

    const iconClasses = `fa fa-${currencyForIcon.toLowerCase()}`;

    return (
      <span
        className="input-group__text"
        data-price-with-currency-symbol
      >
        <span className={iconClasses} />
      </span>
    );
  }

  renderCode = () => {
    if (!Currency.isInternational(this.props.currency)) { return false; }

    return (
      <span
        className="input-group__text"
        data-price-with-currency-currency
      >
        {this.props.currency}
      </span>
    );
  };

  render() {
    return (
      <div className="input-group">
        {this.renderSymbol()}
        <NumericInput
          {...this.props}
          className="input-group__input"
          ref="input"
        />
        {this.renderCode()}
      </div>
    );
  }
}

module.exports = PriceFieldWithCurrency;



// WEBPACK FOOTER //
// ./javascripts/components/shared/price_field_with_currency.jsx